function isBlankString(value) {
    return typeof value === 'string' && /^\s*$/.test(value);
}
function isContentfulString(value) {
    return typeof value === 'string' && !isEmptyOrBlankString(value);
}
function isEmptyOrBlankString(value) {
    return value === undefined || value === null || isBlankString(value);
}
function isEmptyOrEmptyString(value) {
    return value === undefined || value === null || isEmptyString(value);
}
function isEmptyString(value) {
    return typeof value === 'string' && value.length <= 0;
}
export { isBlankString, isContentfulString, isEmptyOrBlankString, isEmptyOrEmptyString, isEmptyString, };
//# sourceMappingURL=strings.js.map